export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY ='35de0df9-067a-4472-a3e9-12ef3a34dcaa';
export const MODAL_CLOSE_SEC = 2.5;
